import { css } from '../utils.js';
import chroma from 'chroma-js';

const themedStyles = css`
    .rc-slider-rail {
      background-color: ${props => props.theme.background_page};
    }

    .rc-slider-track {
      background-color: ${props => props.theme.accent};
    }

    .rc-slider-handle {
      border-color: ${props => props.theme.accent};
      background-color: ${props => props.theme.background_content};
    }

    .rc-slider-handle:hover {
      border-color: ${props => chroma(props.theme.accent).brighten().css()};
    }

    .rc-slider-handle-active:active {
      border-color: ${props => chroma(props.theme.accent).brighten().css()};
      box-shadow: ${props => chroma(props.theme.accent).brighten().css()}; 
    }

    .rc-slider-mark-text-active {
      color: ${props => props.theme.body_text};
    }

    .rc-slider-step {
      background-color: transparent;
    }

    .rc-slider-dot {
      border-color: ${props => chroma(props.theme.accent).alpha(0.5).css()};
      background-color: ${props => props.theme.background_content};
    }

    .rc-slider-dot-active {
      border-color: ${props => props.theme.accent};
    }

    .rc-slider-disabled {
      background-color: ${props => chroma(props.theme.background_page).alpha(0.5).css()};
    }

    .rc-slider-disabled .rc-slider-track {
      background-color: ${props => chroma(props.theme.background_page).alpha(0.5).css()};
    }

    .rc-slider-disabled .rc-slider-handle,
    .rc-slider-disabled .rc-slider-dot {
      border-color: ${props => chroma(props.theme.background_page).alpha(0.5).css()};
      background-color: ${props => chroma(props.theme.background_page).alpha(0.5).css()};
    }

    .rc-slider-tooltip-inner {
      color: ${props => props.theme.body_text};
      background-color: ${props => chroma(props.theme.background_page).alpha(0.5).css()};
      box-shadow: ${props => chroma(props.theme.accent).brighten().css()}; 
    }

    .rc-slider-tooltip-arrow {
      border-color: transparent;
    }

    .rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
      border-top-color: ${props => chroma(props.theme.background_content).alpha(0.5).css()};
    }
`
export default themedStyles;
